var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M13.576 3.945a3.116 3.116 0 0 0 1.389-1.718 6.374 6.374 0 0 1-2.006.753A3.174 3.174 0 0 0 10.655 2C8.912 2 7.5 3.39 7.5 5.103c0 .246.026.48.081.708a9.02 9.02 0 0 1-6.51-3.243 3.06 3.06 0 0 0-.426 1.561c0 1.077.558 2.027 1.405 2.585a3.208 3.208 0 0 1-1.432-.389v.038c0 1.506 1.089 2.76 2.534 3.045a3.145 3.145 0 0 1-1.425.054 3.148 3.148 0 0 0 2.949 2.156 6.403 6.403 0 0 1-3.922 1.33c-.255 0-.506-.015-.753-.044A9.064 9.064 0 0 0 4.84 14.3c5.808 0 8.975-4.682 8.975-8.786 0-.135.005-.318 0-.45a6.28 6.28 0 0 0 1.575-1.608 6.424 6.424 0 0 1-1.814.49z" })
  );
});